function setIncoterms(state, incoterms) {
	state.incoterms = incoterms;
}

function set(state, fn) {
	if (fn)
		fn(state);
}

function setErrors(state, { errors, id }) {
	if (!errors) return;

	state.errors.code = errors.invalidCode || false;
	state.errors.description = errors.invalidDescription || false;
	state.errors.id = id ? id : '';
}

function clearErrors(state) {
	state.errors.code = false;
	state.errors.description = false;
	state.errors.id = '';
}

export default {
	setIncoterms,
	set,
	setErrors,
	clearErrors
};